import { createTailwindMerge } from './create-tailwind-merge.mjs';
import { getDefaultConfig } from './default-config.mjs';

var twMerge = /*#__PURE__*/createTailwindMerge(getDefaultConfig);

export { twMerge };
//# sourceMappingURL=tw-merge.mjs.map
